export const GET_AFTER_SALES_WORKFLOW = "GET_AFTER_SALES_WORKFLOW";